export function startsWithAny(str: string, arr: string[]) {
  return arr.some((subStr) => str.startsWith(subStr))
}
